import React from 'react';
import { UpTick } from '../../../Icons';

interface VIEW_MORE_PROPS {
  onViewMoreClick: () => void;
  text: string;
}

export const ViewMore = ({
  onViewMoreClick,
  text,
}: VIEW_MORE_PROPS): JSX.Element => {
  return (
    <div
      data-testid="past-webinar-view-more"
      onClick={onViewMoreClick}
      className="text-blue-350 cursor-pointer text-s-14 font-semibold gap-2 flex justify-center items-center pt-4"
    >
      <span>{text}</span>
      <UpTick
        colorCode="#1678FB
"
      />
    </div>
  );
};
